'use strict';

var App = require('app');
var AppState = require('app_state');
var Bookmark = require('models/bookmark').Bookmark;
var CommonViews = require('components/common/views');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var SaveConfigurationDialogView = require('components/common/views/bookmark_dialog_view');

var SaveConfiguration = Marionette.ItemView.extend({
    template: require('components/common/templates/bookmark'),
    ui: {
        configuration: '.js-save-configuration',
        selectConfig: '#js-choose-config',
        description: '#js-description',
    },

    events: {
        'click @ui.configuration': 'openConfigDialog',
        'click @ui.description': 'toggleInfo',
        'changed.bs.select @ui.selectConfig': 'switchConfig',
    },

    initialize: function (options) {
        this.collection = options.bookmarks;
        this.configurationsAreEqual = options.configurationsAreEqual || this.configurationsAreEqual;
        var currentConfig = this.options.getCurrentPageConfiguration();
        this.userCanEditPublic = options.userCanEditPublic;
        this.configIsDifferent = false;
        this.page = options.page;

        this.setCurrentBookmarkID(this.getConfigIDByContent(currentConfig));
    },

    serializeData: function () {
        var showInfoButton =
            this.currentBookmarkID &&
            this.collection.get(this.currentBookmarkID) &&
            this.collection.get(this.currentBookmarkID).get('description');

        return {
            currentID: this.currentBookmarkID,
            bookmarks: this.collection.models,
            userCanEditPublic: this.userCanEditPublic,
            showInfoButton: showInfoButton,
            configIsDifferent: this.configIsDifferent && this.currentBookmarkID != 0,
        };
    },

    onRender: function () {
        Misc.initSelectPicker();
    },

    onShow: function () {
        Misc.initSelectPicker();
    },

    setCurrentBookmarkID: function (id) {
        this.currentBookmarkID = id;
    },

    toggleInfo: function () {
        var currentBookmark = this.collection.get(this.currentBookmarkID);

        var title = Handlebars.escapeExpression(currentBookmark.get('name'));
        var description = Handlebars.escapeExpression(currentBookmark.get('description'));

        var hintView = new CommonViews.Confirmation({
            title: title,
            hint: description,
        });
        App.showModal(hintView);
    },

    configurationsAreEqual: function (config1, config2) {
        return JSON.stringify(config1) == JSON.stringify(config2);
    },

    bookmarkChangedOnLoad: function () {
        if (this.currentBookmarkID != 0) {
            Notification.show('warning', i18n.TR('Hinweis'), i18n.TR('Das Lesezeichen konnte nicht geladen werden.'));
            this.currentBookmarkID = 0;
            if (this.options.resetBookmark) {
                this.options.resetBookmark();
            }
            this.render();
        }
    },

    configChanged: function () {
        if (this.currentBookmarkID != 0) {
            if (this.collection.get(this.currentBookmarkID)) {
                this.configIsDifferent = !this.configurationsAreEqual(
                    this.collection.get(this.currentBookmarkID).get('pageConfiguration'),
                    this.options.getCurrentPageConfiguration()
                );
            } else {
                this.configIsDifferent = true;
            }
            // changed to another configuration? -> show this bookmark
            if (this.configIsDifferent) {
                var id = this.getConfigIDByContent(this.options.getCurrentPageConfiguration());
                if (id != 0) {
                    this.setCurrentBookmarkID(id);
                    this.configIsDifferent = false;
                }
            }
            this.render();
        } else {
            var id = this.getConfigIDByContent(this.options.getCurrentPageConfiguration());
            if (id != 0) {
                this.configIsDifferent = false;
                this.setCurrentBookmarkID(id);
                this.render();
            }
        }
    },

    getConfigIDByContent: function (config) {
        var self = this;
        var bookmark = this.collection.find(function (model) {
            return self.configurationsAreEqual(config, model.get('pageConfiguration'));
        });
        if (bookmark) {
            return bookmark.get('id');
        }
        return 0;
    },

    switchConfig: function (e) {
        AppState.clearURLParameterCache();
        var id = parseInt($(this.ui.selectConfig).val());
        // new entry selected or invalid id? -> do not change current settings
        if (isNaN(id) || id == 0) {
            this.setCurrentBookmarkID(0);
            this.render();
            return;
        }

        var newConfig = this.collection.get(id).get('pageConfiguration');
        // configuration is not unique? -> only render, but do not reload
        if (this.configurationsAreEqual(newConfig, this.options.getCurrentPageConfiguration())) {
            this.render();
            return;
        }
        this.options.applyConfig(this.collection.get(id).get('pageConfiguration'));
    },

    openConfigDialog: function () {
        var self = this;
        var isNew = this.currentBookmarkID == 0;
        var bookmark =
            this.collection.get(this.currentBookmarkID) ||
            new Bookmark({
                public: false,
                description: '',
                page: self.page,
            });
        if (bookmark.get('public') && !this.userCanEditPublic) {
            Notification.show(
                'warning',
                i18n.TR('Hinweis'),
                i18n.TR('Sie brauchen administrative Rechte um eine öffentliche Konfigurationen zu verändern.')
            );
            return;
        }

        // new configuration?
        var currentConfiguration = this.options.getCurrentPageConfiguration();
        App.showModal(
            new SaveConfigurationDialogView({
                bookmark: bookmark,
                configuration: currentConfiguration,
                userCanEditPublic: this.userCanEditPublic,
                collection: this.collection,
                callback: function (action, success, id, errorMessage, statusCode) {
                    self.setCurrentBookmarkID(id);
                    var message = '';
                    switch (action) {
                        case 'delete':
                            message = success
                                ? i18n.TR('Das Lesezeichen wurde erfolgreich gelöscht.')
                                : i18n.TR('Das Lesezeichen konnte nicht gelöscht werden.');
                            break;
                        case 'save':
                            if (isNew) {
                                message = success
                                    ? i18n.TR('Das Lesezeichen wurde erfolgreich gespeichert.')
                                    : i18n.TR('Das Lesezeichen konnte nicht gespeichert werden.');
                            } else {
                                message = success
                                    ? i18n.TR('Das Lesezeichen wurde erfolgreich überschrieben.')
                                    : i18n.TR('Das Lesezeichen konnte nicht überschrieben werden.');
                            }
                    }
                    if (success) {
                        self.configChanged();
                        App.hideModal();
                        Notification.show('success', i18n.TR('Erfolg'), message);
                    } else {
                        App.hideModal();
                        if (statusCode == 404 && errorMessage == 'entry_not_found') {
                            message = i18n.TR('Dieses Lesezeichen existiert nicht.');
                        }
                        Notification.show('error', i18n.TR('Fehler'), message);
                    }
                    self.render();
                },
            })
        );
    },
});

module.exports = SaveConfiguration;
